import { HttpFactory, HttpRequestBuilder } from "utils/http";
import { xhrCache } from "utils/cache";
import { diInject } from "stores/diContext";

export class EventService {
  @diInject("api") http: HttpFactory;

  /**
   * Get activity
   * @param id
   */
  get(id): Promise<IEventResult> {
    var req_id = "get_events",
      cache_id = "event_cache_" + id;
    return xhrCache
      .get(req_id, () => this.http.url(`/events/${id}`))
      .stop()
      .cache(cache_id, (_http: HttpRequestBuilder) => {
        return _http.get();
      });
  }

  getSummany(ids) {
    const req_id = `req_${ids.join("-")}`;
    return xhrCache
      .get(req_id, () => this.http.url(`/events/summary?ids=${ids.join(",")}`))
      .stop()
      .data((_http) => _http.get());
  }

  /**
   * Activity browsing statistics
   * @param id
   * @param shareParams
   */
  viewpage(id, shareParams) {
    const { __rn__, ...postData } = shareParams;
    return this.http.url(`/statistics/events/${id}/view_count`).post(postData);
  }

  /**
   * Get ticket information
   * @param event_id
   * @param schedule_id
   * @param paymentMethod
   */
  getTickets(
    event_id,
    schedule_id,
    paymentMethod = "StripeTokenDirect"
  ): Promise<ITicketResult[]> {
    return this.http.url(`/events/${event_id}/tickets`).get({
      scheduleId: schedule_id,
      paymentMethod: paymentMethod,
    });
  }

  /**
   * Get ticket check information
   * @param event_id
   * @param schedule_id
   * @param paymentMethod
   */
  getTicketsCheck(
    event_id,
    schedule_id,
    paymentMethod = "StripeTokenDirect"
  ): Promise<ITicketResultList> {
    return this.http.url(`/events/${event_id}/tickets_check`).get({
      scheduleId: schedule_id,
      paymentMethod: paymentMethod,
    });
  }

  /**
   * Get donation statistics
   * @param event_id
   * @param schedule_id
   */
  getDonations(event_id, schedule_id) {
    return this.http
      .url(`/statistics/events/${event_id}/transaction/donations`)
      .get({
        schedule_id: schedule_id,
      });
  }
  /**
   * Get system information
   */
  getSystemInfo() {
    return this.http.url(`/system/info`).get();
  }

  /**
   * Get discount code information
   * @param event_id
   * @param code
   * @param paymentMethod
   */
  getPromoCode(event_id, code, paymentMethod, gtoken) {
    return xhrCache
      .get("apply-promo-code", () =>
        this.http.url(`/events/${event_id}/couponcodes/${code}`)
      )
      .stop()
      .data((_http) => _http.get({ paymentMethod, gtoken }));
  }

  getEventsByThisProducer(merchantId) {
    const req_id = "get_events_by_this_producer";
    return xhrCache
      .get(req_id, () =>
        this.http.url(
          `/merchants/${merchantId}/events?skip_count=0&max_result_count=23&show_collaborative_events=true&event_status=1`
        )
      )
      .stop()
      .data((_http) => _http.get());
  }

  checkVipCode(eventId, vipCode, gtoken) {
    const req_id = "check_vip_code";
    vipCode = vipCode.trim();
    return xhrCache
      .get(req_id, () =>
        this.http.url(
          `/events/${eventId}/vipcodes/${vipCode}?payment_method=StripeTokenDirect&gtoken=${gtoken}`
        )
      )
      .stop()
      .data((_http) => _http.get());
  }

  getCouponcodes(eventId, code) {
    const req_id = "get_coupon_codes";
    return xhrCache
      .get(req_id, () =>
        this.http.url(
          `/events/${eventId}/couponcodes/${code}?paymentMethod=StripeTokenDirect`
        )
      )
      .stop()
      .data((_http) => _http.get());
  }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/services/events.ts